var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLayout = function SvgLayout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.273 2.047a2.68 2.68 0 0 1 2.678 2.678V19.27c0 1.48-1.199 2.678-2.678 2.678H4.728A2.68 2.68 0 0 1 2.05 19.27V4.725a2.68 2.68 0 0 1 2.678-2.678zm-9.79 18.702h9.79a1.48 1.48 0 0 0 1.479-1.479V9.48H9.482zM3.248 19.27a1.48 1.48 0 0 0 1.479 1.479h3.555V9.479H3.25zM4.728 3.246c-.817 0-1.479.662-1.479 1.479V8.28h17.503V4.725a1.48 1.48 0 0 0-1.479-1.479z"
  })));
};
export default SvgLayout;